<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [commas]="commas" [label]="label" />
